import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { SearchModalContent, SearchModalMask, SearchModalWrapper } from './atoms'

interface Props {
  visible: boolean
  children: React.ReactNode
  top: number
  left: number
  handleMaskClick?: () => void
}

export const SearchModal = ({ visible, children, handleMaskClick, top, left }: Props) => {
  const [isWindow, setIsWindow] = useState(false)

  useEffect(() => {
    setIsWindow(true)
  }, [])

  const modalElement = (
    <SearchModalWrapper>
      <SearchModalMask onClick={() => handleMaskClick?.()} />
      <SearchModalContent $top={top} $left={left}>
        {children}
      </SearchModalContent>
    </SearchModalWrapper>
  )

  return isWindow && visible ? ReactDOM.createPortal(modalElement, document.body) : null
}
